module.exports = __webpack_public_path__ + "img/house.d30e8206.svg";